// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"d644ddc8","231":"f054bc08","327":"1a5b8fad","719":"e0b669bc","721":"7e510042"}[chunkId] + ".chunk.js";
};